import {ActionCreatorDefinition, createAction} from "redux-ts";
import {Alert} from "core/redux/alerts/AlertsReduxState";
import {TSMap} from "typescript-map";

export const SetAlertsType: string = "SetAlerts";
export const SetNewAlertType: string = "SetNewAlert";
export const AddAlertType: string = "AddAlert";
export const SetAlertToEditType: string = "SetAlertToEdit";

export interface SetAlertsPayload {

    alerts: TSMap<number, Alert[]>;
}

export interface SetNewAlertPayload {

    symbolId: number;
    alert: Alert;
}

export interface AddAlertPayload {

    symbolId: number;
    alert: Alert;
}

export interface SetAlertToEditPayload {

    alert: Alert;
}

export const SetAlerts: ActionCreatorDefinition<SetAlertsPayload, any> = createAction<SetAlertsPayload>(SetAlertsType);
export const SetNewAlert: ActionCreatorDefinition<SetNewAlertPayload, any> = createAction<SetNewAlertPayload>(SetNewAlertType);
export const AddAlert: ActionCreatorDefinition<AddAlertPayload, any> = createAction<AddAlertPayload>(AddAlertType);
export const SetAlertToEdit: ActionCreatorDefinition<SetAlertToEditPayload, any> = createAction<SetAlertToEditPayload>(SetAlertToEditType);
